"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EngagementLibrary = void 0;
var react_1 = __importStar(require("react"));
var inversify_react_1 = require("inversify-react");
var cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
var Types_1 = require("@CommonFrontendBackend/Account/Types");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var LibraryPresetCard_1 = require("../LibraryPresetCard");
var UseEngagementAlgorithms_1 = require("./UseEngagementAlgorithms");
var InlineOnboarding_1 = __importDefault(require("InlineOnboarding/InlineOnboarding"));
var PromptTypes_1 = require("@CommonFrontend/Prompt/PromptTypes");
var AlgorithmEditModal_1 = require("./AlgorithmEditModal");
var UpgradeContainer_1 = require("Common/Upgrade/UpgradeContainer");
var presets = __importStar(require("./PresetAlgorithms"));
var styles = __importStar(require("./EngagementLibrary.css"));
var event_tracker_types_1 = require("@qwilr/event-tracker-types");
var AlgorithmCard_1 = require("./AlgorithmCard");
var UpgradeButton_1 = require("Common/Upgrade/UpgradeButton");
var UpgradeTelemetry_1 = require("Common/Upgrade/UpgradeTelemetry");
var HARD_LIMIT_EXPLAINER = "You have reached the maximum of ".concat(Types_1.ENGAGEMENT_ALGORITHM_HARD_LIMIT, " algorithms");
var UPGRADE_BUTTON_TELEMETRY_ORIGIN = "engagement_library_upgrade_button";
var presetsOrder = [presets.proposals, presets.collateral, presets.landingPages, presets.contracts];
var EngagementLibrary = function () {
    var modalService = (0, inversify_react_1.useInjection)("modal");
    var isEnterprisePlan = (0, UpgradeContainer_1.useIsEnterprisePlan)();
    var serverTelemetry = (0, inversify_react_1.useInjection)("serverTelemetry");
    var _a = (0, UseEngagementAlgorithms_1.useEngagementAlgorithms)(), algorithms = _a.algorithms, error = _a.error, create = _a.create, update = _a.update, deleter = _a.deleter;
    var _b = __read((0, react_1.useState)(null), 2), modalState = _b[0], setModalState = _b[1];
    var _c = getLimitFlags(algorithms, isEnterprisePlan), canAddAlgorithm = _c.canAddAlgorithm, isAtEnabledLimit = _c.isAtEnabledLimit, isAtHardLimit = _c.isAtHardLimit, enabledAlgorithmCount = _c.enabledAlgorithmCount, maxEnabledAlgorithms = _c.maxEnabledAlgorithms;
    (0, react_1.useEffect)(function () {
        if (algorithms) {
            serverTelemetry.sendEngagementLibraryViewedTelemetry({
                eventProperties: {
                    engagementAlgorithmsCount: algorithms.length,
                },
            });
        }
    }, [algorithms]);
    function closeModal() {
        setModalState(null);
    }
    function createNew() {
        createWithModal(presets.blankAlgorithm);
        serverTelemetry.sendEngagementAlgorithmCreateStartedTelemetry({
            eventProperties: { eventOrigin: event_tracker_types_1.EventOrigin.EngagementCreateButton },
        });
    }
    function createFromClone(_a) {
        var name = _a.name, description = _a.description, levelsConfiguration = _a.levelsConfiguration;
        var clone = (0, cloneDeep_1.default)({ name: "Cloned from: ".concat(name), description: description, levelsConfiguration: levelsConfiguration });
        createWithModal(clone);
    }
    function createWithModal(algorithm) {
        setModalState({
            algorithm: algorithm,
            onApply: function (newAlgo) {
                return create(__assign({ enabled: !isAtEnabledLimit }, newAlgo));
            },
            isNew: true,
        });
    }
    function createFromPreset(algorithm) {
        serverTelemetry.sendEngagementAlgorithmCreateStartedTelemetry({
            eventProperties: { eventOrigin: event_tracker_types_1.EventOrigin.EngagementPreset, presetName: algorithm.name },
        });
        createWithModal(algorithm);
    }
    function openEditModal(algorithm) {
        setModalState({
            algorithm: algorithm,
            onApply: function (updatedAlgorithm) {
                return update(algorithm._id, __assign({ enabled: algorithm.enabled }, updatedAlgorithm));
            },
            isNew: false,
            pagesMonitored: algorithm.pagesMonitored,
        });
    }
    function deleteWithModal(algorithm) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, modalService.showDeleteModal({
                            header: (react_1.default.createElement(kaleidoscope_1.Stack, { direction: "vertical", gap: "m" },
                                react_1.default.createElement(kaleidoscope_1.Heading, { strong: true, level: "3" }, "Delete algorithm?"),
                                react_1.default.createElement(kaleidoscope_1.Stack, { direction: "vertical", gap: "s" },
                                    react_1.default.createElement(kaleidoscope_1.Text, { element: "p" },
                                        "Are you sure you want to delete the ",
                                        react_1.default.createElement(kaleidoscope_1.Text, { strong: true }, algorithm.name),
                                        " Engagement Algorithm?"),
                                    react_1.default.createElement(kaleidoscope_1.Text, { element: "p" },
                                        "This will stop engagement tracking on all ",
                                        react_1.default.createElement(kaleidoscope_1.Text, { strong: true },
                                            algorithm.pagesMonitored.live,
                                            " pages"),
                                        " being monitored by this algorithm.")))),
                            confirming: function () { return deleter(algorithm._id); },
                            isEscapable: true,
                        })];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    }
    function onEnableToggle(algorithm, isEnabling) {
        return __awaiter(this, void 0, Promise, function () {
            var explainer;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!isEnabling) return [3, 2];
                        return [4, update(algorithm._id, __assign(__assign({}, algorithm), { enabled: true }))];
                    case 1:
                        _a.sent();
                        return [3, 4];
                    case 2:
                        explainer = algorithm.pagesMonitored.live > 0
                            ? "This will stop engagement tracking on all ".concat(algorithm.pagesMonitored.live, " pages being monitored by this algorithm.")
                            : "No pages are being monitored by this algorithm";
                        return [4, modalService.showDeleteModal({
                                title: "Disable \"".concat(algorithm.name, "\" algorithm?"),
                                explainer: explainer,
                                confirming: function () { return update(algorithm._id, __assign(__assign({}, algorithm), { enabled: false })); },
                                confirmLabel: "Disable",
                            })];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2];
                }
            });
        });
    }
    return (react_1.default.createElement("div", { className: styles.wrapper },
        modalState && (react_1.default.createElement(AlgorithmEditModal_1.AlgorithmEditModal, { closeModal: closeModal, onApply: modalState.onApply, algorithm: modalState.algorithm, isNew: modalState.isNew, pagesMonitored: modalState.pagesMonitored })),
        react_1.default.createElement("div", { className: styles.content },
            react_1.default.createElement(kaleidoscope_1.Heading, { level: "2", strong: true }, "Engagement"),
            react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", align: "center", justify: "spaceBetween" },
                react_1.default.createElement(kaleidoscope_1.Text, null,
                    "Create and manage engagement algorithms within Qwilr.",
                    " ",
                    react_1.default.createElement(kaleidoscope_1.Link, { href: "https://help.qwilr.com/article/824-engagement-algorithm" }, "How engagement works.")),
                react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", align: "center", gap: "s", justify: "end" },
                    !isEnterprisePlan && isAtEnabledLimit && (react_1.default.createElement(UpgradeTelemetry_1.UpgradeDiscoveryViewedTelemetry, { telemetryOrigin: UPGRADE_BUTTON_TELEMETRY_ORIGIN },
                        react_1.default.createElement(UpgradeButton_1.UpgradeButton, { telemetryOrigin: UPGRADE_BUTTON_TELEMETRY_ORIGIN }))),
                    react_1.default.createElement(kaleidoscope_1.Tooltip, { content: HARD_LIMIT_EXPLAINER, show: isAtHardLimit ? undefined : false, size: kaleidoscope_1.TooltipSize.Large, wrapTarget: true },
                        react_1.default.createElement(kaleidoscope_1.Button, { onClick: createNew, disabled: !canAddAlgorithm }, "Create engagement algorithm")))),
            react_1.default.createElement(InlineOnboarding_1.default, { title: "Measure engagement on pages", description: react_1.default.createElement(react_1.default.Fragment, null,
                    "Define engagement algorithms to tailor how engagement is measured for reporting on your pages.",
                    react_1.default.createElement("p", null,
                        react_1.default.createElement(kaleidoscope_1.Link, { href: "https://help.qwilr.com/article/824-engagement-algorithm#GetStarted" }, "Read our help docs"),
                        " ",
                        "for more information.")), imageThumbnail: "Assets/Images/onboarding-engagement-library.png", promptId: PromptTypes_1.PromptId.EngagementLibraryOnboarding, enabled: true }),
            error && (react_1.default.createElement(kaleidoscope_1.Alert, { alertType: kaleidoscope_1.AlertType.Error, heading: "Error fetching algorithms" }, "Oh no! There was an error fetching the Engagement Algorithms. Try refreshing the page to fetch them again.")),
            react_1.default.createElement("div", { className: styles.libraryItems }, algorithms && (react_1.default.createElement(react_1.default.Fragment, null, algorithms.map(function (algorithm) {
                return (react_1.default.createElement(AlgorithmCard_1.AlgorithmCard, { key: algorithm._id, algorithm: algorithm, isEnterprisePlan: isEnterprisePlan, isAtEnabledLimit: isAtEnabledLimit, enabledAlgorithmCount: enabledAlgorithmCount, maxEnabledAlgorithms: maxEnabledAlgorithms, clone: createFromClone, openEditModal: openEditModal, deleteWithModal: deleteWithModal, onEnableToggle: onEnableToggle }));
            })))),
            react_1.default.createElement(kaleidoscope_1.Text, { className: styles.presetsHeading, element: "div", strong: true }, "Recommended algorithm presets"),
            react_1.default.createElement("div", { className: styles.libraryItems }, presetsOrder.map(function (p, index) { return (react_1.default.createElement(LibraryPresetCard_1.LibraryPresetCard, { key: index, className: styles.presetCard, theme: "secondary", heading: p.name, description: p.description, disabled: !canAddAlgorithm, disabledReason: isAtHardLimit ? HARD_LIMIT_EXPLAINER : undefined, onClick: function () { return createFromPreset(p); } })); })))));
};
exports.EngagementLibrary = EngagementLibrary;
function getLimitFlags(algorithms, isEnterprisePlan) {
    if (!algorithms) {
        return {
            isAtEnabledLimit: false,
            isAtHardLimit: false,
            canAddAlgorithm: false,
            maxEnabledAlgorithms: 0,
            enabledAlgorithmCount: 0,
        };
    }
    var maxEnabledAlgorithms = isEnterprisePlan
        ? Types_1.ENTERPRISE_ENABLED_ALGORITHMS_LIMIT
        : Types_1.NON_ENTERPRISE_ENABLED_ALGORITHMS_LIMIT;
    var enabledAlgorithmCount = algorithms.reduce(function (count, curr) { return (curr.enabled ? count + 1 : count); }, 0);
    var isAtHardLimit = algorithms.length >= Types_1.ENGAGEMENT_ALGORITHM_HARD_LIMIT;
    return {
        isAtEnabledLimit: enabledAlgorithmCount >= maxEnabledAlgorithms,
        isAtHardLimit: isAtHardLimit,
        canAddAlgorithm: !isAtHardLimit,
        maxEnabledAlgorithms: maxEnabledAlgorithms,
        enabledAlgorithmCount: enabledAlgorithmCount,
    };
}
